export const config = {
  apryseKey: process.env.REACT_APP_APRYSE_KEY || "%%APRYSE_KEY%%",
}
